import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';
import { DatePipe } from '@angular/common';
import { QuestionarioFgenergiaPesquisaComponent } from './questionario-fgenergia-pesquisa/questionario-fgenergia-pesquisa.component';
import { QuestionarioFgenergiaListagemComponent } from './questionario-fgenergia-listagem/questionario-fgenergia-listagem.component';
import { QuestionarioFgenergiaRoutingModule } from './questionario-fgenergia-routing.module';
import {NgSelectModule} from '@ng-select/ng-select';

@NgModule({
    imports: [
        SharedModule,
        QuestionarioFgenergiaRoutingModule,
        NgSelectModule
    ],
  declarations: [
    QuestionarioFgenergiaPesquisaComponent,
    QuestionarioFgenergiaListagemComponent,
  ],
  providers: [
    DatePipe
  ]
})
export class QuestionarioFgenergiaModule { }
